import {
  Component,
  OnDestroy
} from '@angular/core';

import { Subject } from 'rxjs/Subject';

import {
  SkyToken,
  SkyTokenSelectedEventArgs,
  SkyTokensMessageType,
  SkyTokensMessage
} from '../../core';


export class SkyTokensDemoComponent implements OnDestroy {
  public colors: SkyToken[];
  public filters: SkyToken[];
  public tokensController: Subject<SkyTokensMessage>;

  private defaultColors = [
    { name: 'Red' },
    { name: 'Black' },
    { name: 'Blue' },
    { name: 'Brown' },
    { name: 'Green' },
    { name: 'Orange' },
    { name: 'Pink' },
    { name: 'Purple' },
    { name: 'Turquoise' },
    { name: 'White' },
    { name: 'Yellow' }
  ];

  private selectedFilters = [
    { label: 'Canada' },
    { label: 'Older than 55' },
    { label: 'Employed' },
    { label: 'Added before 2018' }
  ];

  constructor() {
    this.createColors();
    this.filters = this.parseTokens(this.selectedFilters);
  }

  public ngOnDestroy() {
    if (this.tokensController) {
      this.tokensController.complete();
    }
  }

  public resetColors() {
    this.createColors();
  }

  public changeColors() {
    this.colors = this.parseTokens([
      { name: 'Red' },
      { name: 'White' },
      { name: 'Blue' }
    ]);
  }

  public destroyColors() {
    this.colors = undefined;
  }

  public createColors() {
    this.colors = this.parseTokens(this.defaultColors);
  }

  public onTokenSelected(args: SkyTokenSelectedEventArgs) {
    console.log('Token selected:', args);
  }

  public onFocusIndexUnderRange() {
    console.log('Focus index was less than zero.');
  }

  public onFocusIndexOverRange() {
    console.log('Focus index was greater than the number of tokens.');
  }

  public focusLastToken() {
    if (!this.tokensController) {
      this.tokensController = new Subject<SkyTokensMessage>();
    }

    this.tokensController.next({
      type: SkyTokensMessageType.FocusLastToken
    });
  }

  private parseTokens(data: any[]): SkyToken[] {
    return data.map((item: any) => {
      return {
        value: item
      } as SkyToken;
    });
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'sky-tokens-demo',
  template: `<h3 class="sky-subsection-heading">
  Default setup
</h3>

<p>
  These tokens can be navigated with the arrow keys, and they can be dismissed with the close buttons.
</p>

<p>
  <sky-tokens
    [(tokens)]="colors">
  </sky-tokens>
</p>

<hr>

<h3 class="sky-subsection-heading">
  Non-dismissible tokens
</h3>

<p>
  These tokens cannot be dismissed, but they can still be navigated with the arrow keys.
</p>

<p>
  <sky-tokens
    [(tokens)]="colors"
    [dismissible]="false">
  </sky-tokens>
</p>

<hr>

<h3 class="sky-subsection-heading">
  Non-focusable tokens
</h3>

<p>
  These tokens cannot be focused using the tab key, but they can still be clicked and navigated with the arrow keys.
</p>

<p>
  <sky-tokens
    [(tokens)]="colors"
    [dismissible]="false"
    [focusable]="false">
  </sky-tokens>
</p>

<hr>

<h3 class="sky-subsection-heading">
  Disabled tokens
</h3>

<p>
  These tokens are disabled and cannot be dismissed or navigated with the arrow keys.
</p>

<p>
  <sky-tokens
    [(tokens)]="colors"
    [disabled]="true">
  </sky-tokens>
</p>

<hr>

<h3 class="sky-subsection-heading">
  Token value interactions
</h3>

<p>
  <button
    class="sky-btn sky-btn-default"
    type="button"
    (click)="changeColors()">
    Change tokens
  </button>

  <button
    class="sky-btn sky-btn-default"
    type="button"
    (click)="resetColors()">
    Reset tokens
  </button>

  <button
    class="sky-btn sky-btn-default"
    type="button"
    (click)="destroyColors()">
    Destroy tokens
  </button>
</p>

<hr>

<h3 class="sky-subsection-heading">
  Custom setup
</h3>

<p>
  These tokens define a custom property to display their values. When users select a token, it emits an event.
</p>

<p>
  <sky-tokens
    displayWith="label"
    [(tokens)]="filters"
    [messageStream]="tokensController"
    (focusIndexOverRange)="onFocusIndexOverRange()"
    (focusIndexUnderRange)="onFocusIndexUnderRange()"
    (tokenSelected)="onTokenSelected($event)">
    (You may also include content inside the tokens component.)
  </sky-tokens>
</p>

<p>
  <button
    class="sky-btn sky-btn-default"
    (click)="focusLastToken()">
    Focus last token
  </button>
</p>
`
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
